import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { getProductsByCategory } from "../services/nonAuthRequets";
import { useParams } from "react-router-dom";
import { S3_URL_PRODUCTS } from "../utils/constants";
import { AuthContext } from "../contexts/AuthContext";
import { addToWishlist } from "../services/authenticatedRequests";
import { toast } from "react-toastify";
import { useWishlist } from "../contexts/WishlistContext";
import ProductCards from "./ProductCards";
import PaginateComponent from "./PaginateComponent";
import NoResultsComponent from "./NoResultsComponent";
import LoadingComponent from "./LoadingComponent";

const CategoryProductListOne = ({ id }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [categoryName, setCategoryName] = useState("");
  const pageSize = 18;

  const fetchProducts = async (page = 0) => {
    try {
      setLoading(true);
      const data = await getProductsByCategory(id, page, pageSize);
      setTotalPages(data.products.totalPages);
      // setProducts((prevProducts) => {
      //   const updatedProducts = [...prevProducts, ...data.products.content];
      //   return Array.from(
      //     new Map(updatedProducts.map((p) => [p.id, p])).values()
      //   );
      // });
      setProducts(data.products.content);
      setCategoryName(data.categoryName);
    } catch (error) {
      console.error("Error searching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // When id changes, reset to first page.
    setProducts([]);
    setCurrentPage(0);
    // Fetch products for the current id and currentPage.
    fetchProducts(0);
  }, [id]);

  // Fetch products on page change (if id hasn't changed).
  useEffect(() => {
    // Avoid re-fetching on initial mount if already fetched by the previous effect.
    
      fetchProducts(currentPage);
    
  }, [currentPage]);
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };


  // const loadMoreProducts = () => {
  //   const nextPage = currentPage + 1;
  //   if (nextPage < totalPages) {
  //     setCurrentPage(nextPage);
  //     fetchProducts(nextPage);
  //   }
  // };
  if (loading) {
    return <LoadingComponent message="Loading products..." />;
  }
  if (products.length === 0) {
    return <NoResultsComponent message="No products found." />;

  }
  document.title = `${categoryName} | Bigmall`;
  return (
    <>
      <ProductCards
        products={products}
      
        //loadMoreProducts={loadMoreProducts}
        showLoadmore={false}
        title={
          categoryName && categoryName.trim() ? categoryName : "Categories"
        }
      />
      <div className="container">
        <PaginateComponent
          totalPages={totalPages}
          currentPage={currentPage}
          handlePageClick={handlePageClick}
        />
      </div>
    </>
  );
};

export default CategoryProductListOne;
